var React = require('react');

function NavIconsEvents (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m22 22h-19.95l9.95-19.95zm-18.23-1h16.51l-8.28-16.64z","key":0}),React.createElement("path",{"d":"m11.48 10.86h1.03v5.37h-1.03z","key":1}),React.createElement("path",{"d":"m12 19a.79.79 0 1 1 .79-.79.79.79 0 0 1 -.79.79z","key":2})]);
}

NavIconsEvents.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsEvents;

NavIconsEvents.default = NavIconsEvents;
